import React, { useEffect, useState } from "react";
import _css from "./TopBarAfterLogin.module.scss";
import { SignOutAltIcon } from "@patternfly/react-icons";
//import { UsersIcon, AngleDownIcon, AngleUpIcon } from "@patternfly/react-icons";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { GetCurrentUser, GetUserQualities } from "api";
import { UserAltIcon } from "@patternfly/react-icons";
import ForcesIcon from "assets/icons/header/forces.png";
import { QUERY_IMAGES } from "services/urls";

const TopBarAfterLogin = ({ userData, setSess }: any) => {
    const accessToken = localStorage.getItem("x-imperso") || localStorage.getItem("x-access-token");
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
//    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);

    const { data: userCompleteData } = useQuery(
        ["SEARCH_CURRENT_USER", { access_token: accessToken }],
        GetCurrentUser
    );

    const { data: userQualities = [] } = useQuery(
        ["FETCH_USER_QUALITIES", { access_token: accessToken }],
        GetUserQualities,
        { enabled: !!userCompleteData }
    );

    const logoutSession = () => {
        localStorage.removeItem("x-access-token");
        localStorage.removeItem("x-imperso");
        setSess(null);
        navigate("/");
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            setWidth(window.innerWidth);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    if(isMobile) return null;

    return (
        <div className={_css.topbar_row}>
            <div className={_css.username}>
                <span>{userCompleteData?.first_name}</span>
                {localStorage.getItem("x-imperso") && (
                    <UserAltIcon
                        size="md"
                        onClick={() => {
                            localStorage.removeItem("x-imperso");
                            window.location.reload();
                        }}
                        className={_css.icon}
                        title="Quitter l'impersonation"
                        style={{ cursor: "pointer", marginLeft: "0.5rem" }}
                    />
                )}
            </div>

            {(width > 1500) && <div className={_css.qualities_container}>
                <div className={_css.qualities_header}>
                    <img src={ForcesIcon} alt="Vos forces" />
                    <span>Vos forces</span>
                </div>
                <div className={`${_css.qualities_list} ${userQualities.length > 3 ? _css.scroll : ""}`}>
                    {userQualities.map((q: any) => (
                        <span key={q.id} className={_css.tag}>{q.name}</span>
                    ))}
                </div>
            </div>}

            {(width > 900) && <div className={_css.hours}>
                <img
                    src={QUERY_IMAGES + "img/2-layers.png"}
                    alt="hours-icon"
                />
                <span>{userCompleteData?.hours?.toFixed(1)}h</span>
            </div>}

            <button className={_css.logout_btn} onClick={logoutSession}>
                <SignOutAltIcon />
            </button>
        </div >
    );
};

export default TopBarAfterLogin;



